import { AppTheme } from '@meitu/saas-ui/es/theme';
import { IImageEffectShadowType, ImageEffectStrokeType } from '@meitu/saas-editor-core/es/version-types';
import { getLocaleStore } from '@/i18n';
import effect1_dark from './assets/effect1_dark.png';
import effect1_xdesign from './assets/effect1_xdesign.png';
import effect1 from './assets/effect1.png';
import effect2_dark from './assets/effect2_dark.png';
import effect2_xdesign from './assets/effect2_xdesign.png';
import effect2 from './assets/effect2.png';
import effect3_dark from './assets/effect3_dark.png';
import effect3_xdesign from './assets/effect3_xdesign.png';
import effect3 from './assets/effect3.png';
import effect4_dark from './assets/effect4_dark.png';
import effect4 from './assets/effect4.png';
import effect5_dark from './assets/effect5_dark.png';
import effect5 from './assets/effect5.png';
import effect6_dark from './assets/effect6_dark.png';
import effect6 from './assets/effect6.png';
import effect7_dark from './assets/effect7_dark.png';
import effect7_xdesign from './assets/effect7_xdesign.png';
import effect7 from './assets/effect7.png';
import effect8_dark from './assets/effect8_dark.png';
import effect8_xdesign from './assets/effect8_xdesign.png';
import effect8 from './assets/effect8.png';
import effect9_dark from './assets/effect9_dark.png';
import effect9_xdesign from './assets/effect9_xdesign.png';
import effect9 from './assets/effect9.png';
import effect10_dark from './assets/effect10_dark.png';
import effect10_xdesign from './assets/effect10_xdesign.png';
import effect10 from './assets/effect10.png';
import effect11_dark from './assets/effect11_dark.png';
import effect11_xdesign from './assets/effect11_xdesign.png';
import effect11 from './assets/effect11.png';
import effect12_dark from './assets/effect12_dark.png';
import effect12_xdesign from './assets/effect12_xdesign.png';
import effect12 from './assets/effect12.png';
import effect13_dark from './assets/effect13_dark.png';
import effect13_xdesign from './assets/effect13_xdesign.png';
import effect13 from './assets/effect13.png';
import strokeType0_dark from './assets/strokeType0_dark.png';
import strokeType0_light from './assets/strokeType0_light.png';
import strokeType1_dark from './assets/strokeType1_dark.png';
import strokeType1_light from './assets/strokeType1_light.png';
import strokeType2_dark from './assets/strokeType2_dark.png';
import strokeType2_light from './assets/strokeType2_light.png';
import strokeType3_dark from './assets/strokeType3_dark.png';
import strokeType3_light from './assets/strokeType3_light.png';

export const ComplexBridgeFilterID = 'ComplexBridge';

export const getDefaultStrokeValue = () => ({
    color: '#2773ffff',
    width: 0.2,
    hidden: false,
    strokeType: ImageEffectStrokeType.normal,
});

export const getDefaultGlowValue = () => ({
    color: '#ffff007f',
    hidden: false,
    width: 0.3,
});

export const getDefaultShadowValue = () => ({
    type: IImageEffectShadowType.base,
    color: '#00000072',
    blur: 0.3,
    hidden: false,
    x: -0.02,
    y: 0,
    rotate: 0,
});

export const getDefaultLightProjectionShadowValue = () => ({
    type: IImageEffectShadowType.lightProjection,
    color: '#2773ff99',
    blur: 0.34,
    hidden: false,
    direction: 86,
    distance: 98,
    opacity: 0.54,
    y: 0,
});

export const getDefaultReflectionShadowValue = () => ({
    type: IImageEffectShadowType.reflection,
    blur: 0.3,
    hidden: false,
    brightness: 10,
    y: 1,
    opacity: 1,
    distance: 27,
});

export const getDefaultWaterSurfaceShadowValue = () => ({
    type: IImageEffectShadowType.waterSurface,
    blur: 0.41,
    opacity: 0.6,
    wave: 40,
    waveNum: 7,
    hidden: false,
    y: 0,
});

export const getStrokeTypeOptions = (theme: string) => {
    const { $t } = getLocaleStore();

    return [
        {
            url: theme !== AppTheme.dark ? strokeType0_light : strokeType0_dark,
            label: $t((v) => v.imageEffectPanel.constants.normal),
            value: ImageEffectStrokeType.normal,
        },
        {
            url: theme !== AppTheme.dark ? strokeType1_light : strokeType1_dark,
            label: $t((v) => v.imageEffectPanel.constants.outSolidLine),
            value: ImageEffectStrokeType.outSolidLine,
        },
        {
            url: theme !== AppTheme.dark ? strokeType2_light : strokeType2_dark,
            label: $t((v) => v.imageEffectPanel.constants.outDashedLine),
            value: ImageEffectStrokeType.outDashedLine,
        },
        {
            url: theme !== AppTheme.dark ? strokeType3_light : strokeType3_dark,
            label: $t((v) => v.imageEffectPanel.constants.tornPaper),
            value: ImageEffectStrokeType.tornPaper,
        },
    ];
};

export const getEmptyEffect = () => ({
    effectAlpha: 1,
    glow: [],
    shadow: [],
    stroke: [],
    screenshotUrl: '',
});

export const getPresetEffectList = (theme: string) => {
    return [
        {
            url: theme !== AppTheme.dark ? effect1 : effect1_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        color: '#00000072',
                        blur: 0.3,
                        hidden: false,
                        x: 0.04330127018922194,
                        y: 0.024999999999999998,
                        type: IImageEffectShadowType.base,
                        rotate: 0,
                    },
                ],
                stroke: [],
                screenshotUrl: '',
            },
            id: 1,
        },

        {
            url: theme !== AppTheme.dark ? effect2 : effect2_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        color: '#69cbf4cc',
                        blur: 0.98,
                        hidden: false,
                        x: 0.007,
                        y: 0,
                        type: IImageEffectShadowType.base,
                    },
                ],
                stroke: [],
                screenshotUrl: '',
            },
            id: 2,
        },

        {
            url: theme !== AppTheme.dark ? effect3 : effect3_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        color: '#00000072',
                        blur: 0.4,
                        hidden: false,
                        x: -0.03,
                        y: 0,
                        type: IImageEffectShadowType.base,
                    },
                ],
                stroke: [],
                screenshotUrl: '',
            },
            id: 3,
        },

        {
            url: theme !== AppTheme.dark ? effect4 : effect4_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [],
                stroke: [
                    {
                        color: '#ffffffff',
                        width: 0.2,
                        hidden: false,
                        strokeType: 0,
                    },
                ],
                screenshotUrl: '',
            },
            id: 4,
        },

        {
            url: theme !== AppTheme.dark ? effect5 : effect5_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        color: '#535353ff',
                        blur: 0.89,
                        hidden: false,
                        x: 0,
                        y: 0,
                        type: IImageEffectShadowType.base,
                    },
                ],
                stroke: [
                    {
                        color: '#ffffffff',
                        width: 0.18,
                        hidden: false,
                        strokeType: 0,
                    },
                ],
                screenshotUrl: '',
            },
            id: 5,
        },

        {
            url: theme !== AppTheme.dark ? effect6 : effect6_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        color: '#535353b2',
                        blur: 0.7,
                        hidden: false,
                        x: -0.032,
                        y: -0.022,
                        type: IImageEffectShadowType.base,
                    },
                ],
                stroke: [
                    {
                        color: '#ffffffff',
                        width: 0.2,
                        hidden: false,
                        strokeType: 0,
                    },
                ],
                screenshotUrl: '',
            },
            id: 6,
        },
        {
            url: theme !== AppTheme.dark ? effect7 : effect7_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        type: IImageEffectShadowType.reflection,
                        blur: 0.3,
                        hidden: false,
                        brightness: 10,
                        y: 1,
                        opacity: 1,
                        distance: 27,
                    },
                ],
                stroke: [],
                screenshotUrl: '',
            },
            id: 7,
        },
        {
            url: theme !== AppTheme.dark ? effect8 : effect8_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        type: IImageEffectShadowType.reflection,
                        blur: 0,
                        hidden: false,
                        brightness: 10,
                        y: 1,
                        opacity: 1,
                        distance: 27,
                    },
                ],
                stroke: [],
                screenshotUrl: '',
            },
            id: 8,
        },
        {
            url: theme !== AppTheme.dark ? effect9 : effect9_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        type: IImageEffectShadowType.waterSurface,
                        blur: 0.41,
                        opacity: 0.6,
                        wave: 40,
                        waveNum: 7,
                        y: 0,
                        hidden: false,
                    },
                ],
                stroke: [],
                screenshotUrl: '',
            },
            id: 9,
        },
        {
            url: theme !== AppTheme.dark ? effect10 : effect10_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        type: IImageEffectShadowType.lightProjection,
                        color: '#53535368',
                        blur: 0.6,
                        hidden: false,
                        direction: 86,
                        distance: 98,
                        opacity: 0.68,
                    },
                ],
                stroke: [],
                screenshotUrl: '',
            },
            id: 10,
        },
        {
            url: theme !== AppTheme.dark ? effect11 : effect11_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        type: IImageEffectShadowType.lightProjection,
                        color: '#53535360',
                        blur: 0.71,
                        hidden: false,
                        direction: -53,
                        distance: 100,
                        opacity: 0.6,
                    },
                ],
                stroke: [],
                screenshotUrl: '',
            },
            id: 11,
        },
        {
            url: theme !== AppTheme.dark ? effect12 : effect12_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        type: IImageEffectShadowType.lightProjection,
                        color: '#000000cc',
                        blur: 0.55,
                        hidden: false,
                        direction: 100,
                        distance: 16,
                        opacity: 80,
                    },
                ],
                stroke: [],
                screenshotUrl: '',
            },
            id: 12,
        },
        {
            url: theme !== AppTheme.dark ? effect13 : effect13_dark,
            effect: {
                effectAlpha: 1,
                glow: [],
                shadow: [
                    {
                        type: IImageEffectShadowType.lightProjection,
                        color: '#000000cc',
                        blur: 0.64,
                        hidden: false,
                        direction: -11,
                        distance: 8,
                        opacity: 0.8,
                    },
                ],
                stroke: [],
                screenshotUrl: '',
            },
            id: 13,
        },
    ];
};

export const getShadowTypeOptions = () => {
    const { $t } = getLocaleStore();
    return [
        {
            label: $t((v) => v.imageEffectPanel.imageShadowType.baseProjection),
            value: IImageEffectShadowType.base,
        },
        {
            label: $t((v) => v.imageEffectPanel.imageShadowType.lightProjection),
            value: IImageEffectShadowType.lightProjection,
        },
        {
            label: $t((v) => v.imageEffectPanel.imageShadowType.reflection),
            value: IImageEffectShadowType.reflection,
        },
        {
            label: $t((v) => v.imageEffectPanel.imageShadowType.waterSurface),
            value: IImageEffectShadowType.waterSurface,
        },
    ];
};
